import { getLocale } from 'i18n/i18nUtils';
import { SortingConfig } from 'rangeConfig/@types';

/*
 * The sorting config will act differently depending on the "compare" property:
 *
 * 1. If the compare function exists, the product lists will not be ML sorted at all.
 * You can either provide a function handling the batch comparison, or just return 0
 * if you want to keep the existing order set by the old "sortOrder" property.
 *
 * 2. If the compare function does not exist, the sorting option will automatically
 * have it's compare function set to use order the products based on the prefetched
 * ml sort list tied to the groupId. If that list doesn't exist (not implemented or
 * the feature is disabled), it will fall back to use "sortOrder"
 */

export const defaultSort = (title: string): SortingConfig => ({
  // Respects the result of "sortOrder"
  id: 'defaultSort',
  title,
  compare: () => 0
});

export const sortByRecommended: SortingConfig = {
  id: 'sortByRecommended',
  title: 'storageone.sortByRecommended'
};

export const sortByName: SortingConfig = {
  id: 'sortByName',
  title: 'storageone.sortByName',
  compare: (batchA, batchB) => batchA.product.name.localeCompare(batchB.product.name, getLocale())
};

export const sortByPriceAscending: SortingConfig = {
  id: 'sortByPriceAscending',
  title: 'storageone.sortByPriceAscending',
  compare: (batchA, batchB) => batchA.getSortingPrice() - batchB.getSortingPrice()
};

export const sortByPriceDescending: SortingConfig = {
  id: 'sortByPriceDescending',
  title: 'storageone.sortByPriceDescending',
  compare: (batchA, batchB) => batchB.getSortingPrice() - batchA.getSortingPrice()
};
